import React, { Component } from "react";
import NumberFormat from "react-number-format";
import Time from "react-time-format";
import { connect } from "react-redux";
import { change_Lang } from "../../../actions/Helper_action";
import "../AllPrint.css";
import converter from "number-to-words";
import { FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
class SellPrintEnglish extends Component {
 render() {
  const {
   lang,
   change_Lang,
   sell_invoice_obj,
   index_sell_contract,
   user,
   primary_logo,
   thirdcolor,
   footer_logo,
   name_en,
  } = this.props;
  // English
  let converter1 =
   sell_invoice_obj.introduction &&
   converter.toWords(sell_invoice_obj.introduction);
  let converter2 =
   sell_invoice_obj.lastPrice && converter.toWords(sell_invoice_obj.lastPrice);
  let converter3 =
   sell_invoice_obj.reject && converter.toWords(sell_invoice_obj.reject);
  let converter4 =
   sell_invoice_obj.pay && converter.toWords(sell_invoice_obj.pay);
  let converter5 =
   sell_invoice_obj.fee && converter.toWords(sell_invoice_obj.fee);

  return (
   <>
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    <br />
    {/* New One */}
    <div className={`${lang === "en" ? "" : "  "}`}>
     <div className="row">
      <div className="col-12">
       <div className="conn">
        <div class="row">
         <div class="col-4">
          <p
           style={{
            fontSize: "16px",
            color: "#000",
            textAlign: "left",
            fontWeight: "bold",
           }}
           class=" text-uppercase"
          >
           &nbsp;&nbsp;{change_Lang("date")} &nbsp;:&nbsp;
           <Time
            value={sell_invoice_obj.createdAt}
            format="YYYY-MM-DD"
            style={{
             fontSize: "16px",
             color: "#000",
             fontWeight: "bold",
            }}
           />
          </p>
         </div>
         <div class="col-4 d-flex justify-content-center">
          <p
           style={{
            fontSize: "20px",
            color: "#000",
            fontWeight: "bolder",
           }}
           class={`d-flex justify-content-center text-uppercase ${
            lang !== "en" ? "fk" : "fkp"
           } `}
          >
           ({change_Lang("sale and purchase contract")})
          </p>
         </div>
         <div class="col-4 text-right">
          <p
           style={{
            fontSize: "16px",
            color: "#000",
            fontWeight: "bold",
           }}
           class=" text-uppercase"
          >
           {change_Lang("contract number")} # &nbsp;&nbsp;
           {index_sell_contract}&nbsp;&nbsp;
          </p>
         </div>
        </div>
        <div class="row mt-1">
         <div class="col-12">
          <div class="form-group row form-inline">
           <label
            style={{
             fontSize: "18px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-2 col-form-label"
           >
            {change_Lang("First Side")}:
           </label>
           <div class="col-sm-4">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "18px" }}
            >
             {sell_invoice_obj.firstname}
            </label>
           </div>
           <label
            style={{
             fontSize: "18px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-2 col-form-label"
           >
            {/* {change_Lang("Witness")}: */}
            {change_Lang("Second Side")}:
           </label>
           <div class="col-sm-4">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "18px" }}
            >
             {sell_invoice_obj.secondname}
            </label>
           </div>
           <label
            style={{
             fontSize: "18px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-2 col-form-label"
           >
            {" "}
            {change_Lang("first_rule_place")}:
           </label>
           <br />
           <div class="col-sm-4">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "18px" }}
            >
             {sell_invoice_obj.available_id &&
              sell_invoice_obj.available_id.Place_ku}
            </label>
           </div>
           {/* shahed 2 */}
           <label
            style={{
             fontSize: "18px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-2 col-form-label"
           >
            {" "}
            property:
           </label>
           <div class="col-sm-4">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "18px" }}
            >
             {/* {sell_invoice_obj.witness2} */}
             {change_Lang(
              sell_invoice_obj.available_id &&
               sell_invoice_obj.available_id.Property
             )}
            </label>
           </div>
           {/* Area */}
           <label
            style={{
             fontSize: "18px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-2 col-form-label"
           >
            Number:
           </label>
           <br />
           <div class="col-sm-4">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "18px" }}
            >
             {sell_invoice_obj.available_id &&
              sell_invoice_obj.available_id.NOoFProperty}
            </label>
           </div>
           {/* shahed 2 */}
           <label
            style={{
             fontSize: "18px",
             color: "black",
             fontWeight: "bold",
            }}
            class="col-sm-2 col-form-label"
           >
            {" "}
            {/* {change_Lang("Witness")}: */}
            {change_Lang("Area")}:
           </label>
           <div class="col-sm-4">
            <label
             class="d-flex justify-content-start"
             style={{ fontWeight: "bold", fontSize: "18px" }}
            >
             {/* {sell_invoice_obj.witness2} */}
             {sell_invoice_obj.available_id &&
              sell_invoice_obj.available_id.Area}
             &nbsp;m<sup>2</sup>
            </label>
           </div>
          </div>
          <p
           style={{
            fontSize: "24px",
            color: "#000",
            backgroundColor: "#ebebeb",
            borderRadius: "0px 50px 0px 0px",
           }}
           class="my-2 d-flex justify-content-center"
          >
           {change_Lang("agreement")}
          </p>
         </div>
        </div>
        <div className="row ">
         <div className="col-12">
          <table className="table table-borderless">
           <tbody>
            <tr
             style={{
              fontSize: "15px",
             }}
            >
             <th
              className={`${lang !== "en" ? "fk" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",
               listStyleType: "circle",
               fontSize: "20px",
              }}
             >
              1.
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "3px",
               color: "black",
               textAlign: "justify",
               fontSize: "22px",
               borderTop: "none",
              }}
             >
              Introduction of the contract is part of this contract and cannot
              be separated from it.
             </td>
            </tr>
            <tr
             style={{
              fontSize: "15px",
             }}
            >
             <th
              className={`${lang !== "en" ? "fk" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",

               listStyleType: "circle",
               fontSize: "20px",
              }}
             >
              2.
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "3px",
               color: "black",

               textAlign: "justify",
               fontSize: "21px",
               borderTop: "none",
              }}
             >
              First Party - Seller / Property Owner Mr. (
              {sell_invoice_obj.firstname}) has full approval to sell his
              property No. (
              {sell_invoice_obj.available_id &&
               sell_invoice_obj.available_id.NOoFProperty}
              ) with an area (
              {sell_invoice_obj.available_id &&
               sell_invoice_obj.available_id.Area}
              ) m2 located in Erbil (
              {sell_invoice_obj.available_id &&
               sell_invoice_obj.available_id.Place_ku}
              ) to the buyer Mr. ({sell_invoice_obj.secondname}).
             </td>
            </tr>
            <tr
             style={{
              fontSize: "15px",
             }}
            >
             <th
              className={`${lang !== "en" ? "fk" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",

               listStyleType: "circle",
               fontSize: "20px",
              }}
             >
              3.
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "3px",
               color: "black",

               textAlign: "justify",
               fontSize: "21px",
               borderTop: "none",
              }}
             >
              Both parties agreed on the price of the property of this contract
              in an amount of (
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={sell_invoice_obj ? sell_invoice_obj.lastPrice : 0}
               required
               className="text-center"
               prefix={`${
                sell_invoice_obj.s_currency === "dolar" ? " $" : " IQD"
               }`}
              />
              ) ({converter2}
              &nbsp;
              {lang === "en" && sell_invoice_obj.s_currency === "dolar"
               ? "($)"
               : lang === "krd" && sell_invoice_obj.s_currency === "dolar"
               ? "US dollars"
               : lang === "arb" && sell_invoice_obj.s_currency === "dolar"
               ? "US dollars"
               : lang === "en" && sell_invoice_obj.s_currency !== "dolar"
               ? "IQD Iraq"
               : lang === "krd" && sell_invoice_obj.s_currency !== "dolar"
               ? "IQD Iraq"
               : lang === "arb" && sell_invoice_obj.s_currency !== "dolar"
               ? "IQD Iraq"
               : ""}
              ).
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "15px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fk" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",

               listStyleType: "circle",
               fontSize: "20px",
              }}
             >
              4.
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "3px",
               color: "black",

               textAlign: "justify",
               fontSize: "21px",
               borderTop: "none",
              }}
             >
              First Party – Property Owner/ Seller received an amount of money
              from the second party as an introduction of this contract during
              signing the contract, an amount of (
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={sell_invoice_obj.pay}
               required
               className="text-center"
               prefix={`${
                sell_invoice_obj.s_currency === "dolar" ? " $" : " IQD"
               }`}
              />
              ) ({converter4}
              &nbsp;
              {lang === "en" && sell_invoice_obj.s_currency === "dolar"
               ? "($)"
               : lang === "krd" && sell_invoice_obj.s_currency === "dolar"
               ? "US dollars"
               : lang === "arb" && sell_invoice_obj.s_currency === "dolar"
               ? "US dollars"
               : lang === "en" && sell_invoice_obj.s_currency !== "dolar"
               ? "IQD Iraq"
               : lang === "krd" && sell_invoice_obj.s_currency !== "dolar"
               ? "IQD Iraq"
               : lang === "arb" && sell_invoice_obj.s_currency !== "dolar"
               ? "IQD Iraq"
               : ""}
              ) is remained on the responsibility of the second party until the
              date of naming the above-mentioned property.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "15px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fk" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",

               listStyleType: "circle",
               fontSize: "20px",
              }}
             >
              5.
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "3px",
               color: "black",

               textAlign: "justify",
               fontSize: "21px",
               borderTop: "none",
              }}
             >
              The second party must pay the remaining amount in point (4) to the
              first party in front of the Erbil Real Estate Registry during the
              confession.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "15px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fk" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",

               listStyleType: "circle",
               fontSize: "20px",
              }}
             >
              6.
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "3px",
               color: "black",

               textAlign: "justify",
               fontSize: "21px",
               borderTop: "none",
              }}
             >
              The first side shall liquidate the costs and fees of water and
              electricity or any other loan before the date of handing over the
              above mention property.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "15px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fk" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",

               listStyleType: "circle",
               fontSize: "20px",
              }}
             >
              7.
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "3px",
               color: "black",

               textAlign: "justify",
               fontSize: "21px",
               borderTop: "none",
              }}
             >
              The first party must hand over the property to the second party on
              the date (
              <Time value={sell_invoice_obj.duedate} format="YYYY-MM-DD" />
              ), and in case a delay occurs in handing over the property of this
              contract by the first party, the first party shall pay (
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={sell_invoice_obj.reject}
               className="text-center"
               prefix={`${
                sell_invoice_obj.s_currency === "dolar" ? " $" : " IQD"
               }`}
              />
              ) ({converter3}
              &nbsp;
              {lang === "en" && sell_invoice_obj.s_currency === "dolar"
               ? "($)"
               : lang === "krd" && sell_invoice_obj.s_currency === "dolar"
               ? "US dollars"
               : lang === "arb" && sell_invoice_obj.s_currency === "dolar"
               ? "US dollars"
               : lang === "en" && sell_invoice_obj.s_currency !== "dolar"
               ? "IQD Iraq"
               : lang === "krd" && sell_invoice_obj.s_currency !== "dolar"
               ? "IQD Iraq"
               : lang === "arb" && sell_invoice_obj.s_currency !== "dolar"
               ? "IQD Iraq"
               : ""}
              ) for each day of delay to the second party.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "15px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fk" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",

               listStyleType: "circle",
               fontSize: "20px",
              }}
             >
              8.
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "3px",
               color: "black",

               textAlign: "justify",
               fontSize: "21px",
               borderTop: "none",
              }}
             >
              In case of regret by either party of the contract, the regretted
              party shall pay an amount of (
              <NumberFormat
               displayType="text"
               thousandSeparator={true}
               value={sell_invoice_obj.fee}
               className="text-center"
               prefix={`${
                sell_invoice_obj.s_currency === "dolar" ? " $" : " IQD"
               }`}
              />
              &nbsp; ({converter5}
              &nbsp;
              {lang === "en" && sell_invoice_obj.s_currency === "dolar"
               ? "($)"
               : lang === "krd" && sell_invoice_obj.s_currency === "dolar"
               ? "US dollars"
               : lang === "arb" && sell_invoice_obj.s_currency === "dolar"
               ? "US dollars"
               : lang === "en" && sell_invoice_obj.s_currency !== "dolar"
               ? "IQD Iraq"
               : lang === "krd" && sell_invoice_obj.s_currency !== "dolar"
               ? "IQD Iraq"
               : lang === "arb" && sell_invoice_obj.s_currency !== "dolar"
               ? "IQD Iraq"
               : ""}
              )) to the other party that is called (criminal condition)
              according to Article (92) of the Civil Law applicable in Kurdistan
              Region, without any judicial judgment.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "15px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fk" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",

               listStyleType: "circle",
               fontSize: "20px",
              }}
             >
              9.
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "1px",
               color: "black",

               textAlign: "justify",
               fontSize: "21px",
               borderTop: "none",
              }}
             >
              The fees of the real estate tax, income tax, water, electricity
              and municipality relevant to the mentioned property is on the
              liability of the first party, unless otherwise agreed.
             </td>
            </tr>
            <tr
             style={{
              fontSize: `${
               lang === "krd" ? "20px" : lang === "arb" ? "22px" : "15px"
              }`,
             }}
            >
             <th
              className={`${lang !== "en" ? "fk" : "fkp"}`}
              scope="row"
              style={{
               color: `${thirdcolor}`,
               borderTop: "none",

               listStyleType: "circle",
               fontSize: "20px",
              }}
             >
              10.
             </th>
             <td
              style={{
               lineHeight: "1.2",
               wordSpacing: "1px",
               color: "black",

               textAlign: "justify",
               fontSize: "21px",
               borderTop: "none",
              }}
             >
              The fee of registration real estate shall be on the responsibility
              of the second party, unless otherwise agreed.
             </td>
            </tr>
           </tbody>
          </table>
         </div>
        </div>
       </div>
       <br />
       <br />
       <br />
       <br />
       <br />
       <br />
       <br />
       <br />
       <div className="row">
        <div className="col-12">
         <table className="table table-borderless">
          <tbody>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "15px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fk" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",

              listStyleType: "circle",
              fontSize: "20px",
             }}
            >
             11.
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "1px",
              color: "black",

              textAlign: "justify",
              fontSize: "21px",
              borderTop: "none",
             }}
            >
             If the property of the contract is not registered in the real
             estate registry, the parties will be free in how they will bear the
             expenditure of transferring the property.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "15px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fk" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",

              listStyleType: "circle",
              fontSize: "20px",
             }}
            >
             12.
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "1px",
              color: "black",

              textAlign: "justify",
              fontSize: "21px",
              borderTop: "none",
             }}
            >
             After signing the contract, the first party must submit the power
             of attorney related to the property of the contract to the lawyer
             Mr. ({sell_invoice_obj.lawman}) appointed by the (Company), and
             submit all the documents with the power of attorney to the lawyer,
             and he will not have the right to request the documents until the
             last phase of registering the property or remove the lawyer. Here,
             the first party is subject to penalty and civil prosecution.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "15px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fk" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",

              listStyleType: "circle",
              fontSize: "20px",
             }}
            >
             13.
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "1px",
              color: "black",

              textAlign: "justify",
              fontSize: "21px",
              borderTop: "none",
             }}
            >
             The first party – property owner - the seller must own or have the
             authority to sell the property according to official documents one
             day before the date of the contract. He must have a new copy of the
             real estate registry and submit it to the buyer and the real estate
             company.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "15px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fk" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",

              listStyleType: "circle",
              fontSize: "20px",
             }}
            >
             14.
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "1px",
              color: "black",

              textAlign: "justify",
              fontSize: "21px",
              borderTop: "none",
             }}
            >
             (DIVINE TIME) Company will receive an amount of (1%) of the total
             price of the property from each party of this contract as a result
             of the services provided to both parties. They (parties) eventually
             reached at a final agreement and contract.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "15px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fk" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",

              listStyleType: "circle",
              fontSize: "20px",
             }}
            >
             15.
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "1px",
              color: "black",

              textAlign: "justify",
              fontSize: "21px",
              borderTop: "none",
             }}
            >
             Both parties of the contract must implement all the terms of the
             contract in good faith.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "15px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fk" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",

              listStyleType: "circle",
              fontSize: "20px",
             }}
            >
             16.
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "1px",
              color: "black",

              textAlign: "justify",
              fontSize: "21px",
              borderTop: "none",
             }}
            >
             The company is not responsible for any problem/ dispute between
             both parties of the contract, but shall be present, when necessary,
             in the specialized court to submit a true and correct explanation
             to the court.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "15px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fk" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",

              listStyleType: "circle",
              fontSize: "20px",
             }}
            >
             17.
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "1px",
              color: "black",

              textAlign: "justify",
              fontSize: "21px",
              borderTop: "none",
             }}
            >
             In case of having any legal problem over the property of the
             contract, the first party must pay the entire amount to the second
             party, and to compensate him if he faces any damage, although this
             legal problem is not at the hands of the first party.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "15px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fk" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",

              listStyleType: "circle",
              fontSize: "20px",
             }}
            >
             18.
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "1px",
              color: "black",

              textAlign: "justify",
              fontSize: "21px",
              borderTop: "none",
             }}
            >
             In case of having any problem/dispute, the court of the place where
             the property of the contract is located will be specialized for
             that concern.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "15px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fk" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",

              listStyleType: "circle",
              fontSize: "20px",
             }}
            >
             19.
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "1px",
              color: "black",

              textAlign: "justify",
              fontSize: "21px",
              borderTop: "none",
             }}
            >
             This contract was signed in Erbil on the date (
             <Time
              value={sell_invoice_obj.createdAt}
              format="YYYY-MM-DD"
              style={{
               fontSize: "22px",
               color: "#342800",
              }}
             />
             ) between the two parties of the contract with their entire
             approval on all the provisions.
            </td>
           </tr>
           <tr
            style={{
             fontSize: `${
              lang === "krd" ? "20px" : lang === "arb" ? "22px" : "15px"
             }`,
            }}
           >
            <th
             className={`${lang !== "en" ? "fk" : "fkp"}`}
             scope="row"
             style={{
              color: `${thirdcolor}`,
              borderTop: "none",

              listStyleType: "circle",
              fontSize: "20px",
             }}
            >
             20.
            </th>
            <td
             style={{
              lineHeight: "1.2",
              wordSpacing: "1px",
              color: "black",
              textAlign: "justify",
              fontSize: "21px",
              borderTop: "none",
             }}
            >
             This contract consists of (20) twenty points and (2) two pages.
            </td>
           </tr>
          </tbody>
         </table>
        </div>
       </div>
       <div className="form-inline">
        <label
         style={{
          fontSize: "16px",
          color: "black",
          textAlign: "justify",
         }}
         className="form-label d-flex justify-content-start"
        >
         {change_Lang("note")}&nbsp;:{sell_invoice_obj.note}
        </label>
       </div>
       <br /> <br /> <br /> <br /> <br />
       <br />
       <br />
       <div className="row">
        <div className="form-group d-flex justify-content-center col-4">
         <label
          style={{
           fontSize: "18px",
           color: "#000",
           fontWeight: "bold",
          }}
          className="form-label"
         >
          First Party (Seller)
         </label>
        </div>

        <div className="col-4">
         <div className="form-group d-flex justify-content-center">
          <label
           style={{
            fontSize: "18px",
            color: "#000",
            fontWeight: "bold",
           }}
           className="form-label"
          >
           Contract Organizor
          </label>
         </div>
        </div>
        <div className="col-4">
         <div className="form-group d-flex justify-content-center">
          <label
           style={{
            fontSize: "18px",
            color: "#000",
            fontWeight: "bold",
           }}
           className="form-label"
          >
           Second Party (Buyer)
          </label>
         </div>
        </div>
       </div>
       <div className="row">
        <div className="col-4 form-group d-flex justify-content-center">
         <label
          style={{
           fontSize: "18px",
           color: "#000",
          }}
          className="form-label"
         >
          {sell_invoice_obj.firstname}
         </label>
        </div>
        <div className="col-4 form-group d-flex justify-content-center">
         <label
          style={{
           fontSize: "18px",
           color: "#000",
          }}
          className="form-label"
         >
          {`${sell_invoice_obj.agentId && sell_invoice_obj.agentId.fname} ${
           sell_invoice_obj.agentId && sell_invoice_obj.agentId.lname
          }`}
         </label>
        </div>
        <div className="col-4">
         <div className="form-group d-flex justify-content-center">
          <label
           style={{
            fontSize: "18px",
            color: "#000",
           }}
           className="form-label"
          >
           {sell_invoice_obj.secondname}
          </label>
         </div>
        </div>
       </div>
      </div>
     </div>
    </div>
   </>
  );
 }
}

const mapStateToProps = (state) => {
 return {
  lang: state.HelperReducer.lang,
  index_sell_contract: state.Invoice_Reducer.index_sell_contract,
  user: state.AuthReducer.user,
  primarycolor: state.HelperReducer.primarycolor,
  secondarycolor: state.HelperReducer.secondarycolor,
  thirdcolor: state.HelperReducer.thirdcolor,
  primary_logo: state.HelperReducer.primary_logo,
  footer_logo: state.HelperReducer.footer_logo,
  name_en: state.HelperReducer.name_en,
 };
};

const mapDispatchToProps = (dispatch) => {
 return {
  change_Lang: (key) => dispatch(change_Lang(key)),
 };
};

export default connect(mapStateToProps, mapDispatchToProps)(SellPrintEnglish);
